module.exports = __webpack_public_path__ + "ddaf190a32030b323ab31c45ac155f19.png";